import { FaqItem } from '@/components/FaqItem';
import { useSiteContent } from '@/hooks/useSiteContent';

import styles from './FrequentlyAskedQuestions.module.css';
import { useFaqAccordion } from './useFaqAccordion';
export const FrequentlyAskedQuestions = () => {
  const { content } = useSiteContent();
  const { openId, toggle } = useFaqAccordion('');

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>Frequently Asked Questions</h2>
      <div className={styles.card}>
        {content.faqItems.map((faq) => {
          const isOpen = openId === faq.id;

          return (
            <FaqItem
              key={faq.id}
              id={faq.id}
              question={faq.question}
              answer={faq.answer}
              isOpen={isOpen}
              onToggle={() => {
                toggle(faq.id);
              }}
            />
          );
        })}
      </div>
    </section>
  );
};
